import {
	Box,
	Divider,
	FormHelperText,
	FormControl,
	Grid,
	MenuItem,
	OutlinedInput,
	TextField,
	Table,
	TableContainer,
	TableBody,
	TableCell,
	tableCellClasses,
	TableHead,
	TableRow,
	ToggleButtonGroup,
	ToggleButton,
	Typography,
	Button,
	Paper,
	Select
} from "@mui/material"
import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import React, { useEffect, useMemo, useRef } from "react"
import { useSelector, useDispatch } from "react-redux"
import { styled } from "@mui/styles"
import { makeStyles } from "@mui/styles"
import { useNavigate, useLocation } from "react-router-dom"
import { useTranslation } from "react-i18next"
import cssVariables from "../../../../theme/cssVariables"
import { useFormik } from 'formik'
import * as yup from 'yup'
import * as Util from "../../../../services/global.service"

import { ReactComponent as PlusIcon } from "../../../../icons/plus-bigger.svg"
import { ReactComponent as EditIcon } from "../../../../assets/icons/edit.svg"
import { ReactComponent as AlertRed } from "../../../../icons/alert-red.svg"
import { ReactComponent as InfoIcon } from "../../../../assets/icons/info.svg"
import { ReactComponent as ApprovedIcon } from "../../../../assets/images/iconStatus/approved.svg"
import { ReactComponent as CalendarIcon } from "../../../../assets/icons/calendar-month.svg"
import CustomCheckbox from "../../../../components/CustomCheckbox"
import IOSSwitch from "../../../../components/IOSSwitch"
import RedStarRequired from "../../../../components/RedStarRequired"

import SwiperCore, { Navigation, Pagination } from 'swiper'
import { Swiper, SwiperSlide } from "swiper/react"
// swiper core styles
import 'swiper/swiper.min.css'
import 'swiper/swiper-bundle.min.css'
// swiper modules styles
import 'swiper/components/navigation/navigation.min.css'
import 'swiper/components/pagination/pagination.min.css'

import WorkflowDialog from "../../../../components/adminConfigWorkflow/WorkflowDialog"
import EditSectionDialog from "../../../../components/adminConfigWorkflow/EditSectionDialog"
import MessageDialog from "../../../../components/MessageDialog"
import ConfirmDialog from "../../../../components/ConfirmDialog"

import { getWorkflow, getWorkflowTemplate, postCreateWorkflow, postWorkflowStep, putWorkflowStep, putWorkflow, getWorkflowStep, putWorkflowSection } from "../../../../actions/admin/workflow"

SwiperCore.use([Navigation, Pagination])

const useStyles = makeStyles({
	root: {
		display: "flex",
		width: "100%",
		flexWrap: "wrap",
	},
	tableHeader: {
		fontWeight: 500,
		fontSize: "14px!important",
		color: "#A0A0A0",
	},
	paperRoot: {
		paddingTop: "24px!important",
		paddingBottom: "24px!important",
		paddingLeft: "32px!important",
		paddingRight: "32px!important",
		boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.1)!important",
		borderRadius: "10px!important",
	},
	swiperStyles: {
		overflow: "hidden",
		'& .swiper-container': {
			position: "relative!important",
			width: "100%",
			overflow: "unset!important"
		},
		'& div > .swiper-wrapper': {
			position: "unset!important"
		},
		'& div > .swiper-slide': {
			display: "flex",
			alignItems: "center"
		},
		'& div > .swiper-button-next, .swiper-button-prev': {
			"background- color": "white",
			"background- color": "rgba(255, 255, 255, 0.5)",
			padding: "12px",
			color: "#5DA196 !important",
			fill: "#5DA196 !important",
			stroke: "#5DA196 !important",
			border: "1px solid #5DA196",
			borderRadius: "3px",
			height: "20px",
			width: "20px",
			right: "0px",
			top: "-15px",
		},
		'& div > .swiper-button-prev': {
			right: "40px!important",
			left: "auto!important"
		},
		'& div >.swiper-button-next:after,.swiper-button-prev:after': {
			"font-size": "12px"
		},
		'& div > .swiper-pagination, .swiper-pagination-fraction': {
			bottom: "auto",
			left: "auto",
			width: "auto",
			right: "100px",
			top: "-34px",
			"font-family": "'Kanit'",
			"font-size": "14px",
			"line-height": "21px",
			"font-weight": 400,
			'& .swiper-pagination-current': {
				color: "#5DA196 !important"
			},
		},
	},
})

const BootstrapTooltip = styled(({ className, ...props }) => (
	<Tooltip {...props} arrow classes={{ popper: className }} />
))(({ theme }) => ({
	[`& .${tooltipClasses.arrow}`]: {
		color: "#343A40",
	},
	[`& .${tooltipClasses.tooltip}`]: {
		backgroundColor: "#343A40",
		color: "#FFFFFF",
		padding: "11px 15px",
	},
}));

const StyledPaper = (props) => {
	const classes = useStyles();
	return (
		<Paper
			classes={{ root: classes.paperRoot }}
			{...props}
		>
			{props.children}
		</Paper>
	);
};

const StyledTableCellEvaluate = styled(TableCell)(({ theme }) => ({
	[`&.${tableCellClasses.head}`]: {
		backgroundColor: "#FAFAFA",
		borderTop: "1px solid #E5E5E5!important",
		borderBottom: "1px solid #E5E5E5!important",
		borderLeft: "0!important",
		borderRight: "0!important",
	},
	[`&.${tableCellClasses.head}:nth-of-type(6)`]: {
		padding: "0!important",
	},
	[`&.${tableCellClasses.body}`]: {
		backgroundColor: "#FFF",
		fontSize: 14,
	},
	"&:nth-of-type(1)": {
		width: "5%",
	},
	"&:nth-of-type(2)": {
		width: "5%",
	},
	"&:nth-of-type(3)": {
		width: "15%",
	},
	"&:nth-of-type(4)": {
		width: "30%",
	},
	"&:nth-of-type(5)": {
		width: "6%",
	},
	"&:nth-of-type(6)": {
		width: "6%",
	},
	"&:nth-of-type(7)": {
		width: "6%",
	},
	"&:nth-of-type(8)": {
		width: "6%",
	},
	"&:nth-of-type(9)": {
		width: "6%",
	},
	"&:nth-of-type(10)": {
		width: "10%",
	},
}))

const StyledTableRow = styled(TableRow)(({ theme }) => ({
	"&:nth-of-type(odd)": {
		backgroundColor: theme.palette.action.hover,
	},
}))

const StyledTableEvaluate = (props) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const { doEdit, doEditSection, isStepValid, isSubmitButtonClicked, doValidate, ...oProps } = props
	let finalStepList = oProps?.staticData ?? []
	let dynamicStepList = oProps?.dynamicData ?? []
	let sectionList = oProps?.sectionData?.filter(section => section.code === "evaluate")?.[0] ?? []
	let finalSection = oProps?.sectionData?.filter(section => section.code === "final")?.[0] ?? []

	const LocalErrorHelper = (props) => {
		const { text } = { ...props }
		return (
			<Box sx={{ display: "flex", justifyContent: "start", alignItems: "center" }}>
				<AlertRed />
				<FormHelperText
					error={true}
					sx={{ ml: 1, fontWeight: 500, fontSize: "14px" }}
				>
					{
						text ? text : t("adminWorkflow.label.pleaseFillEndDate")
					}
				</FormHelperText>
			</Box>
		)
	}

	const CellData = (rProps) => {
		let { list } = rProps
		let fieldsLength = list?.fields?.length ?? 1
		return (
			<>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{`${list?.step}.` || ""}
					</Typography>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{list?.action?.label || ""}
					</Typography>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" sx={fieldsLength > 1 ? { borderLeft: "1px solid rgba(224, 224, 224, 1)", borderRight: "1px solid rgba(224, 224, 224, 1)" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{list?.fields?.length > 0 ? list?.fields[0]?.label : ""}
					</Typography>
					{
						(list?.fields?.length > 0 && list?.fields[0]?.value) &&
						<Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
							{list?.fields[0]?.value?.name || ""}
						</Typography>
					}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							height: "fit-content",
							minHeight: "50px"
						}}
					>
						<Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
							{list?.description?.en || ""}
						</Typography>
						<Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
							{list?.description?.th || ""}
						</Typography>
					</Box>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.options?.hide_score_self) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.action?.code === "approve" && list?.options?.reject) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.options?.edit) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{list?.is_send_mail ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
			</>
		)
	}

	return (
		<TableContainer component={"div"} {...props}>
			<Table sx={{ minWidth: 650 }} aria-label="data table">
				<TableHead>
					<StyledTableRow>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.seq")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.action")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.field")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.description")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="center">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.hideScoreToSelf")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="center">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.reject")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="center">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.editable")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="center">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.email")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.action")}
							</Typography>
						</StyledTableCellEvaluate>
					</StyledTableRow>
				</TableHead>
				<TableBody>
					{
						sectionList?.list?.map((section, index) => {
							return (
								<>
									<StyledTableRow>
										<StyledTableCellEvaluate align="left" colSpan={9}>
											<Box sx={{ display: "flex", flexDirection: "column" }}>
												<Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
													<Typography fontSize={16} fontWeight="600" color="#5DA196" sx={{ mr: 1 }}>{section.descriptionEN} ({section.descriptionTH})</Typography>
													<BootstrapTooltip
														title={t("label.edit")}
														placement="top"
													>
														<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEditSection(section, "")} />
													</BootstrapTooltip>
													{
														(section.days === "" && isSubmitButtonClicked) ? <LocalErrorHelper /> :
															(!doValidate("evaluate", index) && isSubmitButtonClicked) ? <LocalErrorHelper text={t("adminWorkflow.label.sectionError1")} /> : <></>
													}
												</Box>
												<Box sx={{ display: "flex", alignItems: "center" }}>
													<Typography fontSize={14} fontWeight="500" color={section.days !== "" ? "#404349" : "#CC6058"}>{t("adminWorkflow.label.endDate1")}: {section.days === "" ? "-" : section.days} {t("adminWorkflow.label.endDate2")}</Typography>
												</Box>
											</Box>
										</StyledTableCellEvaluate>
									</StyledTableRow>
									{
										dynamicStepList.map((list, index) => {
											if (list.seq === section.seq) {
												let fieldsLength = list?.fields?.length ?? 1
												if (fieldsLength === 1) {
													return (
														<>
															<StyledTableRow>
																<CellData list={list} />
																<StyledTableCellEvaluate align="left">
																	<Box sx={{ display: "flex", flexDirection: "space-between" }}>
																		<Box sx={{ display: "flex", alignItems: "center" }}>
																			<BootstrapTooltip
																				title={t("label.edit")}
																				placement="top"
																			>
																				<EditIcon style={{ cursor: "pointer" }} onClick={() => doEdit(list, "evaluate")} />
																			</BootstrapTooltip>
																		</Box>
																	</Box>
																</StyledTableCellEvaluate>
															</StyledTableRow>
														</>
													)
												} else if (fieldsLength > 1) {
													let result = []
													list.fields.forEach((fieldRow, fIndex) => {
														if (fIndex === 0) {
															result.push(
																<StyledTableRow>
																	<CellData list={list} />
																	<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
																		<Box sx={{ display: "flex", flexDirection: "space-between" }}>
																			<Box sx={{ display: "flex", alignItems: "center" }}>
																				<BootstrapTooltip
																					title={t("label.edit")}
																					placement="top"
																				>
																					<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEdit(list, "evaluate")} />
																				</BootstrapTooltip>
																			</Box>
																		</Box>
																	</StyledTableCellEvaluate>
																</StyledTableRow>
															)
														} else {
															result.push(
																<StyledTableRow>
																	{/* value data */}
																	<StyledTableCellEvaluate align="left" sx={{ borderLeft: "1px solid rgba(224, 224, 224, 1)", borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
																		<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
																			{fieldRow.label}
																		</Typography>
																		{
																			(fieldRow?.value) &&
																			<Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
																				{fieldRow?.value?.name || ""}
																			</Typography>
																		}
																	</StyledTableCellEvaluate>
																</StyledTableRow>
															)
														}
													})
													return result
												}
											}
										})
									}
								</>
							)
						})
					}

					{/* section */}
					<StyledTableRow>
						<StyledTableCellEvaluate align="left" colSpan={9}>
							<Box sx={{ display: "flex", flexDirection: "column" }}>
								<Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
									<Typography fontSize={16} fontWeight="600" color="#5DA196" sx={{ mr: 1 }}>{finalSection.descriptionEN} ({finalSection.descriptionTH})</Typography>
									<BootstrapTooltip
										title={t("label.edit")}
										placement="top"
									>
										<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEditSection(finalSection, "final")} />
									</BootstrapTooltip>
									{
										(finalSection.days === "" && isSubmitButtonClicked) ? <LocalErrorHelper /> :
											(!doValidate("final") && isSubmitButtonClicked) ? <LocalErrorHelper text={t("adminWorkflow.label.sectionError2")} /> : <></>
									}
								</Box>
								<Box sx={{ display: "flex", alignItems: "center" }}>
									<Typography fontSize={14} fontWeight="500" color={finalSection.days !== "" ? "#404349" : "#CC6058"}>{t("adminWorkflow.label.endDate1")}: {finalSection.days === "" ? "-" : finalSection.days} {t("adminWorkflow.label.endDate2")}</Typography>
								</Box>
							</Box>
						</StyledTableCellEvaluate>
					</StyledTableRow>
					{/* final step */}
					{
						finalStepList.map((list, index) => {
							let fieldsLength = list?.fields?.length ?? 1
							if (fieldsLength === 1) {
								return (
									<>
										<StyledTableRow>
											<CellData list={list} />
											<StyledTableCellEvaluate align="left">
												<Box sx={{ display: "flex", flexDirection: "space-between" }}>
													<Box sx={{ display: "flex", alignItems: "center" }}>
														<BootstrapTooltip
															title={t("label.edit")}
															placement="top"
														>
															<EditIcon style={{ cursor: "pointer" }} onClick={() => doEdit(list, "final")} />
														</BootstrapTooltip>
													</Box>
												</Box>
											</StyledTableCellEvaluate>
										</StyledTableRow>
									</>
								)
							} else if (fieldsLength > 1) {
								let result = []
								list.fields.forEach((fieldRow, fIndex) => {
									if (fIndex === 0) {
										result.push(
											<StyledTableRow>
												<CellData list={list} />
												<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
													<Box sx={{ display: "flex", flexDirection: "space-between" }}>
														<Box sx={{ display: "flex", alignItems: "center" }}>
															<BootstrapTooltip
																title={t("label.edit")}
																placement="top"
															>
																<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEdit(list, "final")} />
															</BootstrapTooltip>
														</Box>
													</Box>
												</StyledTableCellEvaluate>
											</StyledTableRow>
										)
									} else {
										result.push(
											<StyledTableRow>
												{/* value data */}
												<StyledTableCellEvaluate align="left" sx={{ borderLeft: "1px solid rgba(224, 224, 224, 1)", borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
													<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
														{fieldRow.label}
													</Typography>
													{
														(fieldRow?.value) &&
														<Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
															{fieldRow?.value?.name || ""}
														</Typography>
													}
												</StyledTableCellEvaluate>
											</StyledTableRow>
										)
									}
								})
								return result
							}
						})
					}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

const StyledTableEvaluateExtend = (props) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const { doEdit, doEditSection, isStepValid, ...oProps } = props
	let stepList = oProps?.data ?? []
	const CellData = (rProps) => {
		let { list } = rProps
		let fieldsLength = list?.fields?.length ?? 1
		return (
			<>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{`${list?.step}.` || ""}
					</Typography>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{list?.action?.label || ""}
					</Typography>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" sx={fieldsLength > 1 ? { borderLeft: "1px solid rgba(224, 224, 224, 1)", borderRight: "1px solid rgba(224, 224, 224, 1)" } : {}}>
					<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
						{list?.fields?.length > 0 ? list?.fields[0]?.label : ""}
					</Typography>
					{
						(list?.fields?.length > 0 && list?.fields[0]?.value) &&
						<Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
							{list?.fields[0]?.value?.name || ""}
						</Typography>
					}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					<Box
						sx={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "space-between",
							height: "fit-content",
							minHeight: "50px"
						}}
					>
						<Typography sx={{ fontSize: "16px", fontWeight: 500 }}>
							{list?.description?.en || ""}
						</Typography>
						<Typography sx={{ fontSize: "14px", fontWeight: 400 }}>
							{list?.description?.th || ""}
						</Typography>
					</Box>
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.options?.hide_score_self) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.action?.code === "approve" && list?.options?.reject) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{(list?.options?.edit) ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
				<StyledTableCellEvaluate align="center" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
					{list?.is_send_mail ? <CustomCheckbox disabled defaultChecked sx={fieldsLength > 1 ? { pt: "2px!important" } : {}} /> : <></>}
				</StyledTableCellEvaluate>
			</>
		)
	}

	return (
		<TableContainer component={"div"} {...props}>
			<Table sx={{ minWidth: 650 }} aria-label="data table">
				<TableHead>
					<StyledTableRow>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.seq")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.action")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.field")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.description")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="center">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.hideScoreToSelf")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="center">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.reject")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="center">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.editable")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="center">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.email")}
							</Typography>
						</StyledTableCellEvaluate>
						<StyledTableCellEvaluate align="left">
							<Typography classes={{ root: classes.tableHeader }}>
								{t("adminWorkflow.label.action")}
							</Typography>
						</StyledTableCellEvaluate>
					</StyledTableRow>
				</TableHead>
				<TableBody>
					{
						stepList.map((list, index) => {
							let fieldsLength = list?.fields?.length ?? 1
							if (fieldsLength === 1) {
								return (
									<>
										<StyledTableRow>
											<CellData list={list} />
											<StyledTableCellEvaluate align="left">
												<Box sx={{ display: "flex", flexDirection: "space-between" }}>
													<Box sx={{ display: "flex", alignItems: "center" }}>
														<BootstrapTooltip
															title={t("label.edit")}
															placement="top"
														>
															<EditIcon style={{ cursor: "pointer" }} onClick={() => doEdit(list, "evaluate", "extend")} />
														</BootstrapTooltip>
													</Box>
												</Box>
											</StyledTableCellEvaluate>
										</StyledTableRow>
									</>
								)
							} else if (fieldsLength > 1) {
								let result = []
								list.fields.forEach((fieldRow, fIndex) => {
									if (fIndex === 0) {
										result.push(
											<StyledTableRow>
												<CellData list={list} />
												<StyledTableCellEvaluate align="left" rowSpan={fieldsLength} sx={fieldsLength > 1 ? { verticalAlign: "top" } : {}}>
													<Box sx={{ display: "flex", flexDirection: "space-between" }}>
														<Box sx={{ display: "flex", alignItems: "center" }}>
															<BootstrapTooltip
																title={t("label.edit")}
																placement="top"
															>
																<EditIcon style={{ cursor: "pointer", marginRight: "15px" }} onClick={() => doEdit(list, "evaluate", "extend")} />
															</BootstrapTooltip>
														</Box>
													</Box>
												</StyledTableCellEvaluate>
											</StyledTableRow>
										)
									} else {
										result.push(
											<StyledTableRow>
												{/* value data */}
												<StyledTableCellEvaluate align="left" sx={{ borderLeft: "1px solid rgba(224, 224, 224, 1)", borderRight: "1px solid rgba(224, 224, 224, 1)" }}>
													<Typography sx={{ fontSize: "16px", fontWeight: 400 }}>
														{fieldRow.label}
													</Typography>
													{
														(fieldRow?.value) &&
														<Typography sx={{ fontSize: "14px", fontWeight: 400 }} color="#D8D8D8">
															{fieldRow?.value?.name || ""}
														</Typography>
													}
												</StyledTableCellEvaluate>
											</StyledTableRow>
										)
									}
								})
								return result
							}
						})
					}
				</TableBody>
			</Table>
		</TableContainer>
	)
}

const ErrorHelper = (props) => {
	const { t } = useTranslation();
	const { text } = props
	return (
		<Grid container mt={0}>
			<Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
				<AlertRed />
				<FormHelperText
					error={true}
					sx={{ ml: 1 }}
				>
					{
						!text ? t("label.pleaseFillOutThisField") : text
					}
				</FormHelperText>
			</Grid>
		</Grid>)
}

const EvaluationProbationWorkflow = (props) => {
	const classes = useStyles()
	const { t } = useTranslation()
	const dispatch = useDispatch()
	const navigate = useNavigate()
	const { state } = useLocation()
	const { id, mode } = props

	const [stepType, setStepListType] = React.useState("")
	const [workflowId, setWorkflowId] = React.useState("")
	const [workflowData, setWorkflowData] = React.useState("")
	const [originalEditData, setOriginalEditData] = React.useState([])
	const [stepList, setStepList] = React.useState([])
	const [extendStepList, setExtendStepList] = React.useState([])
	const [templateStepList, setTemplateStepList] = React.useState([])
	const [adjustableStepList, setAdjustableStepList] = React.useState([])
	const [adjustableStepsRows, setAdjustableStepRows] = React.useState(0)
	const [sectionList, setSectionList] = React.useState([
		{
			code: "evaluate",
			list: [
				{
					seq: 1,
					descriptionTH: "30 วัน",
					descriptionEN: "30 Days",
					days: "",
					isEditable: true
				}
			]
		},
		{
			code: "final",
			descriptionTH: "สุดท้าย",
			descriptionEN: "Final",
			days: "",
			isEditable: false
		}
	])
	const [isStepListEmptyDialogOpen, setIsStepListEmptyDialogOpen] = React.useState(false)
	const [isStepValid, setIsStepValid] = React.useState(false)
	const [isComponentCheckboxesValid, setIsComponentCheckboxesValid] = React.useState(false)
	const [componentCheckList, setComponentCheckList] = React.useState([])
	const [sectionTotal, setSectionTotal] = React.useState([1, 2, 3, 4])

	const goToAdmin = (route, data) => {
		if (data) {
			navigate("/admin" + route, { replace: false, state: data });
		} else {
			navigate("/admin" + route, { replace: false });
		}
	}

	const handleComponentCheckList = (val) => {
		let checkList = [...componentCheckList]
		if (checkList.includes(val)) checkList = checkList.filter(component => component != val)
		else checkList.push(val)
		setComponentCheckList(checkList)
	}

	const [isSubmitButtonClicked, setIsSubmitButtonClicked] = React.useState(false)

	// formik validation
	const validationSchema = yup.object({
		code: yup.string().required(),
		type: yup.string().required(),
		name: yup.string().min(1).required(),
		status: yup.boolean().required(),
		description: yup.string().min(1).required(),
		evaluationAmount: yup.number().min(1).required(),
	});
	const formik = useFormik({
		initialValues: {
			code: "",
			type: "",
			name: "",
			status: true,
			description: "",
			evaluationAmount: 1
		},
		enableReinitialize: true,
		validationSchema: validationSchema,
		onSubmit: () => {
			console.log("submit")
			if (mode === "edit") {
				handleSubmitUpdate()
			} else {
				handleSubmitCreate()
			}
		},
	})

	// preview lang & data
	const [previewLang, setPreviewLang] = React.useState("EN");
	const handleChangePreviewLang = (e, val) => {
		setPreviewLang(val);
	}
	const [isConfirmDiscardDialogOpen, setIsconfirmDiscardDialogOpen] = React.useState(false)
	const handleConfirmDiscard = () => {
		setIsconfirmDiscardDialogOpen(false, goToAdmin("/workflow"))
	}


	const [willChangeEvaluationAmount, setWillChangeEvaluationAmount] = React.useState(1)
	const handleWillChangeEvaluationAmount = (val) => {
		setIsConfirmChangeEvalAmountDialogOpen(true)
		setWillChangeEvaluationAmount(val)
	}
	const [isConfirmChangeEvalAmountDialogOpen, setIsConfirmChangeEvalAmountDialogOpen] = React.useState(false)
	const handleConfirmChangeEvalAmount = () => {
		handleChangeEvaluationAmout(willChangeEvaluationAmount)
		setIsConfirmChangeEvalAmountDialogOpen(false)
	}

	// workflow dialog
	const [isWorkflowDialogOpen, setIsEvaluationWorkflowDialogOpen] = React.useState(false)
	const [countStep, setCountStep] = React.useState(0)
	const handleCloseWorkflowDialog = () => {
		setIsEvaluationWorkflowDialogOpen(false)
	}

	const [isEditSectionOpen, setIsEditSectionOpen] = React.useState(false)
	const [editSectionData, setEditSectiondata] = React.useState(false)

	const handleEditSectionDialog = (val, stepType = "") => {
		setIsEditSectionOpen(true)
		let tmpVal = {
			...val,
			stepType
		}
		setEditSectiondata(tmpVal)
	}

	const [templateId, setTemplateId] = React.useState("")
	const [extendSectionId, setExtendSectionId] = React.useState("")
	const [workflowTemplateData, setWorkflowTemplateData] = React.useState([])
	const [isUsed, setIsUsed] = React.useState(false)
	const [isOnlyStep, setIsOnlyStep] = React.useState(false)

	const handleName = (e) => {
		formik.setFieldTouched('name', true)
		formik.setFieldValue("name", e.target.value)
	}
	const handleDescription = (e) => {
		formik.setFieldTouched('description', true)
		formik.setFieldValue("description", e.target.value)
	}
	const handleChangeEvaluationAmout = (val) => {
		formik.setFieldTouched('evaluationAmount', true)
		formik.setFieldValue("evaluationAmount", val)

		let additionalStep = []
		let templateStep = JSON.parse(JSON.stringify(templateStepList))?.filter(list => list?.action?.section.includes("evaluate"))
		let templateFinalStep = JSON.parse(JSON.stringify(templateStepList))?.filter(list => list?.action?.section.includes("final"))
		let tmpOriginalEditData = originalEditData ? JSON.parse(JSON.stringify(originalEditData)) : []
		let tmpOriginalSectionsData = tmpOriginalEditData?.sections
		let tmpSectionList = []
		let duration = 30
		for (let i = 1; i <= val; i++) {
			let original = tmpOriginalSectionsData?.filter(filterItem => filterItem.type === "evaluate") ?? []
			if (i <= original.length) {
				original = original?.find(section => section.seq === i)
			} else {
				original = null
			}
			templateStep.forEach((item, index) => {
				let isStepExisted = original?.steps?.find(step => step?.action?.code === item?.action?.code)
				if (isStepExisted) {
					additionalStep.push({
						...item,
						id: isStepExisted?.id,
						seq: i,
					})
				} else {
					additionalStep.push({
						...item,
						seq: i
					})
				}
			})

			if (original) {
				tmpSectionList.push({
					seq: i,
					descriptionTH: `${duration} วัน`,
					descriptionEN: `${duration} Days`,
					days: "",
					isEditable: true,
					id: original?.id ?? ""
				})
			} else {
				tmpSectionList.push({
					seq: i,
					descriptionTH: `${duration} วัน`,
					descriptionEN: `${duration} Days`,
					days: "",
					isEditable: true
				})
			}
			duration = duration + 30
		}
		// set final step list
		let tmpFinalStepList = []
		let originalFinal = undefined
		originalFinal = tmpOriginalSectionsData?.find(section => section.type === "final")
		templateFinalStep.forEach((item, index) => {
			let isStepExisted = originalFinal?.steps?.find(step => step?.action?.code === item?.action?.code)
			if (isStepExisted) {
				tmpFinalStepList.push({
					...item,
					id: isStepExisted?.id
				})
			} else {
				tmpFinalStepList.push({
					...item
				})
			}

		})
		setStepList(tmpFinalStepList)

		// set final section
		let tmpFinalSection = {}
		if (originalFinal) {
			tmpFinalSection = {
				code: "final",
				descriptionTH: `สุดท้าย`,
				descriptionEN: `Final`,
				days: "",
				isEditable: true,
				id: originalFinal?.id ?? ""
			}
		} else {
			tmpFinalSection = {
				code: "final",
				descriptionTH: `สุดท้าย`,
				descriptionEN: `Final`,
				days: "",
				isEditable: true
			}
		}
		let resultSectionList = [...sectionList].map(section => {
			if (section.code === "evaluate") {
				section.list = tmpSectionList
			} else if (section.code === "final") {
				section = tmpFinalSection
			}
			return section
		})
		setSectionList(resultSectionList)
		setAdjustableStepList(additionalStep)
	}

	const fetchTemplateData = () => {
		dispatch(getWorkflowTemplate("probation")).then((resp) => {
			let notFinalSection = 0
			let templateSteps = resp?.steps ?? []
			setTemplateStepList(templateSteps)
			setExtendStepList(templateSteps)
			if (resp?.fields && resp?.actions) {
				notFinalSection = resp.actions.length
				let workflowTemplateData = {
					actions: resp.actions,
					fields: resp.fields
				}
				// default checkbox
				let componentCheckList = []
				resp.actions.forEach(action => {
					if (action?.section?.includes("final")) {
						--notFinalSection
					}
					componentCheckList.push(action.code)
				})
				setAdjustableStepRows(notFinalSection)
				if (mode !== "edit") setComponentCheckList(componentCheckList)
				setWorkflowTemplateData(workflowTemplateData)
			}
			if (mode !== "edit") {
				if (templateSteps && templateSteps.length > 0) {
					// set default status
					let adjustableSteps = []
					let steps = []
					resp.steps.forEach((item, index) => {
						if (index < notFinalSection) {
							adjustableSteps.push({
								...item,
								status: "active",
								seq: 1
							})
						} else {
							steps.push({
								...item,
								status: "active",
							})
						}
					})
					setStepList(steps)
					setAdjustableStepList(adjustableSteps)
					if (templateSteps[0]?.template_id) setTemplateId(templateSteps[0].template_id)
				}
			}

			if (resp?.total_section) setSectionTotal(Array.from({ length: resp?.total_section ?? 4 }, (_, i) => i + 1))
		})
	}

	const fetchWorkflowData = (step = false) => {
		if (id && id !== "") {
			setIsOnlyStep(step)
			dispatch(getWorkflow(id)).then(resp => {
				let workflow = resp?.workflow ?? null
				if (workflow) {
					setWorkflowData(workflow)
				}
			})
		}
	}

	const checkedLang = (data) => {
		if (previewLang === "EN") {
			if (data.en && data.en !== "") {
				return data.en
			} else {
				return data.th
			}
		} else {
			if (data.th && data.th !== "") {
				return data.th
			} else {
				return data.en
			}
		}
	}

	const [editStepData, setEditStepData] = React.useState({})
	const [typeWorkflowTemplate, setTypeWorkflowTemplate] = React.useState({})

	const handleEditStep = (step, listType = "", stepType = "") => {
		let tmpStep = { ...step, listType, stepType }
		if (mode === "edit" && step.id) {
			dispatch(getWorkflowStep(step.id)).then(resp => {
				if (resp?.workflow_step?.id) {
					tmpStep = {
						...tmpStep,
						stepAssignId: resp?.workflow_step?.id
					}
				}
				setEditStepData(tmpStep, setIsEvaluationWorkflowDialogOpen(true))
				setTypeWorkflowTemplate("edit")
			})
		} else {
			setEditStepData(tmpStep, setIsEvaluationWorkflowDialogOpen(true))
			setTypeWorkflowTemplate("edit")
		}
	}

	const handleSubmitDialog = (data) => {
		let listType = data?.listType
		let stepType = data?.stepType
		let tmpStepList = stepType === "extend" ? [...filteredExtendStepList] : listType === "evaluate" ? [...filteredAdjustableStepList] : [...filteredFinalStepList]
		let findActions = searchActions(data.action)
		let findFields = searchFields(data.field)
		let findList = tmpStepList.find(item => item.step === data.step)
		if (findFields?.length > 0) {
			if (findList?.fields?.length > 1) {
				let tmpField = []
				findList.fields.forEach((item, index) => {
					if (item.code === "self") {
						tmpField.push(item)
					} else {
						let formatField = {
							...findFields[0],
							value: null
						}
						if (data?.value) {
							formatField.value = {
								code: data.value.code,
								id: data.value.value,
								name: data.value.oName
							}
						}
						tmpField.push(formatField)
					}
				})
				findFields = tmpField
			} else {
				let formatField = {
					...findFields[0],
					value: null
				}
				if (data?.value) {
					formatField.value = {
						code: data.value.code,
						id: data.value.value,
						name: data.value.oName
					}
				}
				findFields[0] = formatField
			}
		}
		if (typeWorkflowTemplate === "edit") {
			if (mode !== "edit" || !data.id) {
				let newList = null
				if (data.step !== 1) {
					newList = {
						...findList,
						actions: findActions,
						fields: findFields,
						description: {
							en: data?.descriptionEN || "",
							th: data?.descriptionTH || ""
						},
						tooltip: {
							en: data?.tooltipEN || "",
							th: data?.tooltipTH || ""
						},
						is_send_mail: data?.emailNotice,
						options: {
							...findList?.options,
							edit: data?.editable,
							hide_score_self: data?.hideScoreToSelf,
							reject: data?.reject
						}
					}
				} else {
					newList = {
						...findList,
						fields: findFields,
						description: {
							en: data?.descriptionEN || "",
							th: data?.descriptionTH || ""
						},
						tooltip: {
							en: data?.tooltipEN || "",
							th: data?.tooltipTH || ""
						},
						is_send_mail: data?.emailNotice,
						options: {
							...findList?.options,
							edit: data?.editable,
							hide_score_self: data?.hideScoreToSelf,
							reject: data?.reject
						}
					}
				}
				tmpStepList = tmpStepList.map(old => (old.step === newList.step) ? newList : old)
				if (stepType !== "extend") {
					if (listType === "evaluate") {
						setAdjustableStepList(tmpStepList, handleCloseWorkflowDialog())
					} else {
						setStepList(tmpStepList, handleCloseWorkflowDialog())
					}
				} else {
					setExtendStepList(tmpStepList, handleCloseWorkflowDialog())
				}
			} else if (mode === "edit" && data.id) {
				// update value for current list
				let findListByID = tmpStepList.find(item => item.id === data.id)
				let newList = null
				if (data.step !== 1) {
					newList = {
						...findListByID,
						actions: findActions,
						fields: findFields,
						description: {
							en: data?.descriptionEN || "",
							th: data?.descriptionTH || ""
						},
						tooltip: {
							en: data?.tooltipEN || "",
							th: data?.tooltipTH || ""
						},
						is_send_mail: data?.emailNotice,
						options: {
							...findListByID?.options,
							edit: data?.editable,
							hide_score_self: data?.hideScoreToSelf,
							reject: data?.reject
						}
					}
				} else {
					newList = {
						...findListByID,
						fields: findFields,
						description: {
							en: data?.descriptionEN || "",
							th: data?.descriptionTH || ""
						},
						tooltip: {
							en: data?.tooltipEN || "",
							th: data?.tooltipTH || ""
						},
						is_send_mail: data?.emailNotice,
						options: {
							...findListByID?.options,
							edit: data?.editable,
							hide_score_self: data?.hideScoreToSelf,
							reject: data?.reject
						}
					}
				}
				tmpStepList = tmpStepList.map(old => (old.id === newList.id) ? newList : old)
				if (stepType !== "extend") {
					if (listType === "evaluate") {
						setAdjustableStepList(tmpStepList, handleCloseWorkflowDialog())
					} else {
						setStepList(tmpStepList, handleCloseWorkflowDialog())
					}
				} else {
					setExtendStepList(tmpStepList, handleCloseWorkflowDialog())
				}

				findFields = findFields.length > 1 ? findFields.filter(field => field.code !== "self") : findFields
				// update value for API
				let newListForAPI = {
					step: data?.step,
					action: findActions?.code || "",
					field: findFields.length > 0 ? findFields[0].id : "",
					value: data?.value?.value || "",
					description_th: data?.descriptionTH || "",
					description_en: data?.descriptionEN || "",
					tooltip_th: data?.tooltipTH || "",
					tooltip_en: data?.tooltipEN || "",
					is_send_mail: data?.emailNotice,
					is_edit: data?.editable,
					is_hide_score_self: data?.hideScoreToSelf,
					is_reject: data?.reject,
				}
				dispatch(putWorkflowStep(data?.stepAssignId, newListForAPI)).then(resp => {
					handleCloseWorkflowDialog()
				})
			}
		} else if (typeWorkflowTemplate === "add") {
			if (mode !== "edit") {
				if (findFields?.length > 0) {
					if (data?.value) {
						findFields[0] = {
							...findFields[0],
							value: {
								code: data.value.code,
								id: data.value.value,
								name: data.value.oName
							},
						}
					}
				}
				let newList = {
					step: data?.step,
					action: findActions,
					fields: findFields,
					description: {
						en: data?.descriptionEN || "",
						th: data?.descriptionTH || ""
					},
					tooltip: {
						en: data?.tooltipEN || "",
						th: data?.tooltipTH || ""
					},
					is_send_mail: data?.emailNotice,
					options: {
						edit: data?.editable,
						hide_score_self: data?.hideScoreToSelf,
						reject: data?.rejct
					}
				}
				tmpStepList = [...filteredAdjustableStepList]
				tmpStepList.push(newList)
				if (stepType !== "extend") {
					if (listType === "evaluate") {
						setAdjustableStepList(tmpStepList, handleCloseWorkflowDialog())
					} else {
						setStepList(tmpStepList, handleCloseWorkflowDialog())
					}
				} else {
					setExtendStepList(tmpStepList, handleCloseWorkflowDialog())
				}
			} else if (mode === "edit") {
				let newList = {
					workflow_id: workflowId,
					step: data?.step,
					action: findActions?.code || "",
					field: findFields.length > 0 ? findFields[0].id : "",
					value: data?.value?.value || "",
					description_th: data?.descriptionTH || "",
					description_en: data?.descriptionEN || "",
					tooltip_th: data?.tooltipTH || "",
					tooltip_en: data?.tooltipEN || "",
					is_send_mail: data?.emailNotice,
					is_edit: data?.editable,
					is_hide_score_self: data?.hideScoreToSelf,
					is_reject: data?.reject,
				}
				dispatch(postWorkflowStep(newList)).then(resp => {
					handleCloseWorkflowDialog()
					fetchWorkflowData(true)
				})
			}
		}
	}

	const searchActions = (search) => {
		let result = [...workflowTemplateData.actions].find(workflow => workflow.code === search)
		return result
	}

	const searchFields = (search) => {
		let result = [...workflowTemplateData.fields].filter(workflow => workflow.code === search)
		return result
	}

	const formatStepList = (adjustSteps, finalSteps, extendSteps, sectionList) => {
		// seperate step by section (seq)
		let tmpSectionList = [...sectionList]
		let formattedSectionList = []
		let countSection = 0
		let lastStepBeforeExtend = 0
		tmpSectionList.forEach(section => {
			if (section.code === "evaluate") {
				section.list.forEach(list => {
					formattedSectionList.push({
						"description_th": list.descriptionTH,
						"description_en": list.descriptionEN,
						"duration": parseInt(list.days),
						"type": "evaluate",
						"seq": list.seq,
						"steps": [],
						"id": list?.id ?? "",
						"status": "active"
					})
					++countSection
				})
			} else if (section.code === "final") {
				formattedSectionList.push({
					"description_th": section.descriptionTH,
					"description_en": section.descriptionEN,
					"duration": parseInt(section.days),
					"type": "final",
					"seq": ++countSection,
					"steps": [],
					"id": section?.id ?? "",
					"status": "active"
				})
			}
		})
		// set steps into corresponding section
		let tmpObj = {}
		let tmpArray = [...adjustSteps, ...finalSteps]
		tmpArray.sort((a, b) => a.step - b.step).forEach(item => {
			tmpObj = {
				...tmpObj,
				id: item?.id ?? "",
				step: item.step,
				action: item?.action?.code,
				field: item?.fields?.length > 0 ? item.fields[0].id : "",
				description_th: item.description.th,
				description_en: item.description.en,
				tooltip_th: item.tooltip.th,
				tooltip_en: item.tooltip.en,
				status: item.status,
				is_send_mail: item.is_send_mail ?? false,
				is_edit: item?.options?.edit ?? false,
				is_hide_score_self: item?.options?.hide_score_self ?? false,
				is_reject: item?.options?.reject ?? false,
				template_id: item?.template_id ?? templateId,
				status: "active"
			}
			lastStepBeforeExtend = item.step
			if (item?.fields?.length > 1) {
				let fields = item?.fields?.filter(item => item.code !== "self")
				if (fields.length > 0) {
					tmpObj = {
						...tmpObj,
						field: fields?.length > 0 ? fields[0].id : "",
					}
					if (fields?.[0]?.value && fields?.[0]?.value?.id) {
						tmpObj = {
							...tmpObj,
							value: fields?.[0]?.value?.id
						}
					}
				}
			} else {
				if (item?.fields?.[0]?.value && item?.fields?.[0]?.value?.id) {
					tmpObj = {
						...tmpObj,
						value: item?.fields?.[0]?.value?.id
					}
				}
			}
			if (item?.options?.is_edit || item?.options?.edit) {
				tmpObj = {
					...tmpObj,
					is_edit: item?.options?.is_edit || item?.options?.edit
				}
			}
			formattedSectionList = formattedSectionList.map(section => {
				if (section.type === "evaluate") {
					if (section.seq === item.seq) {
						section.steps.push(tmpObj)
					}
				} else if (section.type === "final" && !item.seq) {
					section.steps.push(tmpObj)
				}
				return section
			})
		})

		// extend steps 
		// add extend section
		formattedSectionList.push({
			"description_th": "ต่อเวลา",
			"description_en": "Extended",
			"duration": 0,
			"type": "extend",
			"seq": countSection + 1,
			"steps": [],
			"id": extendSectionId,
			"status": "active"
		})
		// add extend steps
		tmpObj = {}
		extendSteps.sort((a, b) => a.step - b.step).forEach(item => {
			++lastStepBeforeExtend
			tmpObj = {
				...tmpObj,
				id: item.id,
				step: lastStepBeforeExtend,
				action: item?.action?.code,
				field: item?.fields?.length > 0 ? item.fields[0].id : "",
				description_th: item.description.th,
				description_en: item.description.en,
				tooltip_th: item.tooltip.th,
				tooltip_en: item.tooltip.en,
				status: item.status,
				is_send_mail: item.is_send_mail ?? false,
				is_edit: item?.options?.edit ?? false,
				is_hide_score_self: item?.options?.hide_score_self ?? false,
				is_reject: item?.options?.reject ?? false,
				template_id: item?.template_id ?? templateId,
				status: "active"
			}
			if (item?.fields?.length > 1) {
				let fields = item?.fields?.filter(item => item.code !== "self")
				if (fields.length > 0) {
					tmpObj = {
						...tmpObj,
						field: fields?.length > 0 ? fields[0].id : "",
					}
					if (fields?.[0]?.value && fields?.[0]?.value?.id) {
						tmpObj = {
							...tmpObj,
							value: fields?.[0]?.value?.id
						}
					}
				}
			} else {
				if (item?.fields?.[0]?.value && item?.fields?.[0]?.value?.id) {
					tmpObj = {
						...tmpObj,
						value: item?.fields?.[0]?.value?.id
					}
				}
			}
			if (item?.options?.is_edit || item?.options?.edit) {
				tmpObj = {
					...tmpObj,
					is_edit: item?.options?.is_edit || item?.options?.edit
				}
			}
			formattedSectionList = formattedSectionList.map(section => {
				if (section.type === "extend") {
					section.steps.push(tmpObj)
				}
				return section
			})
		})
		return formattedSectionList
	}

	const [sectionDaysValidate, setSectionDaysValidate] = React.useState([])
	const checkSectionDateNumber = (data) => {
		let tmpSection = data ? data : [...sectionList]
		let normalSections = tmpSection.find(item => item.code === "evaluate")
		let finalSections = tmpSection.find(item => item.code === "final")
		let resultValidate = []
		// check normal sections
		if (normalSections && normalSections?.list?.length > 0) {
			normalSections = normalSections.list
			for (let i = normalSections.length - 1; i > 0; i--) {
				for (let index = i - 1; index >= 0; index--) {
					if (Util.formatData(normalSections?.[i]?.days, false) !== false && Util.formatData(normalSections?.[index]?.days, false) !== false) {
						let day1 = Number(normalSections?.[i]?.days)
						let day2 = Number(normalSections?.[index]?.days)
						if (day2 > 0 && day1 > 0 && day1 <= day2) {
							resultValidate.push({
								code: "evaluate",
								index: i,
							})
						}
					}
				}
			}
		}
		// check final section
		if (finalSections) {
			if (Util.formatData(finalSections?.days, false) !== false && Util.formatData(normalSections?.[normalSections.length - 1]?.days, false) !== false) {
				if (Number(finalSections?.days) < Number(normalSections?.[normalSections.length - 1]?.days)) {
					resultValidate.push({
						code: "final"
					})
				}
			}
		}
		setSectionDaysValidate(resultValidate)
		return resultValidate.length > 0 ? false : true
	}

	const getValidateSectionData = (section, index) => {
		let sectionsList = [...sectionDaysValidate]
		let result = false
		if (section === "final") {
			result = sectionsList.find(item => item.code === "final")
			if (!result) {
				result = true
			} else {
				result = false
			}
		} else {
			result = sectionsList.filter(item => item.code === "evaluate")
			if (result?.length > 0) {
				result = result.find(item => item.index === index)
				if (!result) {
					result = true
				} else {
					result = false
				}
			} else {
				result = true
			}
		}
		return result
	}

	const validateSectionEndDate = () => {
		let result = true
		sectionList.forEach(section => {
			if (section.code === "evaluate") {
				section.list.forEach(list => {
					result = list.days === "" ? false : true
				})
			} else {
				result = section.days === "" ? false : true
			}
		})
		return result
		// return false
	}

	const handleSubmitForm = () => {
		formik.submitForm()
		dispatch({
			type: "SCROLL_TO_ERROR",
			payload: true,
		})
		setIsSubmitButtonClicked(true)
	}

	const [isSuccessCreateDialogOpen, setIsSuccessCreateDialogOpen] = React.useState(false)
	const handleSuccessCreateDialog = () => {
		setIsSuccessCreateDialogOpen(false, goToAdmin("/workflow"))
		setIsSuccessCreateDialogOpen(false)
	}

	const [isSuccessSaveSectionDialogOpen, setIsSuccessSaveSectionDialogOpen] = React.useState(false)
	const handleSuccessSaveSectionDialog = () => {
		setIsSuccessSaveSectionDialogOpen(false)
	}
	const [isFailSaveSectionDialogOpen, setIsFailSaveSectionDialogOpen] = React.useState(false)
	const handleFailSaveSectionDialog = () => {
		setIsFailSaveSectionDialogOpen(false)
	}

	const handleSubmitCreate = () => {
		let formattedStepList = formatStepList(filteredAdjustableStepList, filteredFinalStepList, filteredExtendStepList, sectionList)
		let data = {
			code: formik.values.code,
			name: formik.values.name,
			status: formik.values.status ? "active" : "inactive",
			description: formik.values.description,
			type: "probation",
			component: componentCheckList,
			sections: formattedStepList,
		}
		let isSectionDaysValid = checkSectionDateNumber()
		if (isComponentCheckboxesValid && validateSectionEndDate() && isSectionDaysValid) {
			dispatch(postCreateWorkflow(data)).then(resp => {
				setIsSuccessCreateDialogOpen(true)
			})
		}
	}

	const [isSuccessUpdateDialogOpen, setIsSuccessUpdateDialogOpen] = React.useState(false)
	const handleSuccessUpdateDialog = () => {
		setIsSuccessUpdateDialogOpen(false, goToAdmin("/workflow"))
	}
	const handleSubmitUpdate = () => {
		let formattedStepList = formatStepList(filteredAdjustableStepList, filteredFinalStepList, filteredExtendStepList, sectionList)
		let data = {
			code: formik.values.code,
			name: formik.values.name,
			status: formik.values.status ? "active" : "inactive",
			description: formik.values.description,
			type: "probation",
			component: componentCheckList,
			sections: formattedStepList,
		}
		let isSectionDaysValid = checkSectionDateNumber()
		if (isComponentCheckboxesValid && validateSectionEndDate() && isSectionDaysValid) {
			dispatch(putWorkflow(id, data)).then(() => {
				setIsSuccessUpdateDialogOpen(true)
			})
		}
	}

	const setDataForEdit = (data) => {
		if (!isOnlyStep) {
			formik.setFieldValue("code", data?.code ?? "")
			formik.setFieldValue("type", data?.type ?? "")
			formik.setFieldValue("name", data?.name ?? "")
			formik.setFieldValue("status", data?.status === "active" ? true : false)
			formik.setFieldValue("description", data?.description ?? "")
		}
		setIsUsed(data?.is_used ?? false)
		setWorkflowId(data?.id || "")

		let tmpSectionList = data?.sections
		let evaluateSectionList = tmpSectionList.filter(section => section?.type === "evaluate")
		let finalSectionList = tmpSectionList.filter(section => section?.type === "final")
		let extendSectionList = tmpSectionList.filter(section => section?.type === "extend")
		if (tmpSectionList?.length > 0) {
			if (!isOnlyStep) {
				// set evaluation amount
				formik.setFieldValue("evaluationAmount", evaluateSectionList.length ?? 1)
				// set checkboxes
				let componentCheckboxes = []
				extendSectionList.forEach(extend => {
					setExtendSectionId(extend.id)
					extend?.steps?.forEach(step => {
						if (step?.action?.code) componentCheckboxes.push(step.action.code)
					})
				})
				setComponentCheckList(componentCheckboxes)
			}
			let tmpCurrentSectionDataList = [...sectionList]
			let tmpEvalSectionList = []
			// set final section data
			tmpCurrentSectionDataList = tmpCurrentSectionDataList.map(section => {
				if (section.code === "final") {
					if (finalSectionList.length > 0) {
						section.descriptionEN = finalSectionList[0].description?.en ?? ""
						section.descriptionTH = finalSectionList[0].description?.th ?? ""
						section.days = finalSectionList[0].duration ?? 0
						section.id = finalSectionList[0].id ?? ""
					}
				} else if (section.code === "evaluate") {
					evaluateSectionList.forEach((item, index) => {
						tmpEvalSectionList.push({
							descriptionEN: item.description?.en ?? "",
							descriptionTH: item.description?.th ?? "",
							days: item.duration ?? 0,
							id: item.id ?? "",
							seq: item.seq ?? index + 1
						})
					})
					section.list = tmpEvalSectionList
				}
				return section
			})
			setSectionList(tmpCurrentSectionDataList)
			// set section steps
			if (evaluateSectionList.length > 0) {
				let evalStepList = []
				evaluateSectionList.forEach((evaluate, eIndex) => {
					evaluate.steps.forEach(step => {
						evalStepList.push({
							...step,
							seq: evaluate.seq ?? eIndex + 1
						})
					})
				})
				setAdjustableStepList(evalStepList)
			}
			if (finalSectionList.length > 0) setStepList(finalSectionList[0].steps)
			if (extendSectionList.length > 0) setExtendStepList(extendSectionList[0].steps)
		}
	}

	const handleUpdateSectionData = (data) => {
		setIsSubmitButtonClicked(true)
		let stepListType = data?.stepType !== "final" ? "evaluate" : "final"
		setStepListType(stepListType)
		let tmpSectionList = JSON.parse(JSON.stringify(sectionList))
		let currentSectionList = tmpSectionList?.find(section => section.code === stepListType) ?? undefined
		let currentEditSection = null
		if (currentSectionList) {
			// if (mode !== "edit") {
			currentEditSection = stepListType === "evaluate" ? currentSectionList?.list?.find(list => list?.seq === data?.seq) : currentSectionList
			// }
		}
		let listThatUpdate = null
		let resultList = tmpSectionList
		let isSectionValid = false
		if (currentEditSection) {
			currentEditSection.descriptionEN = data?.descEN
			currentEditSection.descriptionTH = data?.descTH
			currentEditSection.days = data?.endDays
			// merge edit result in list
			if (stepListType !== "final") {
				listThatUpdate = currentSectionList.list.map(list => {
					if (list.seq === currentEditSection.seq) {
						return {
							...list,
							descriptionEN: currentEditSection.descriptionEN,
							descriptionTH: currentEditSection.descriptionTH,
							days: currentEditSection.days
						}
					} else {
						return list
					}
				})
			}

			if (stepListType !== "final") {
				currentSectionList = {
					...currentSectionList,
					list: listThatUpdate
				}
			} else {
				currentSectionList = {
					...currentSectionList,
					descriptionEN: currentEditSection.descriptionEN,
					descriptionTH: currentEditSection.descriptionTH,
					days: currentEditSection.days
				}
			}
			resultList = resultList.map(section => {
				if (section.code === stepListType) {
					section = currentSectionList
				}
				return section
			})
		}
		setIsEditSectionOpen(false)
		isSectionValid = checkSectionDateNumber(resultList)
		if (mode === "edit") {
			if (!isSectionValid) {
				setIsFailSaveSectionDialogOpen(true)
			} else if (data?.id && data?.id !== "") {
				let tmpData = {
					"description_th": data.descTH,
					"description_en": data.descEN,
					"duration": parseInt(data.endDays)
				}
				dispatch(putWorkflowSection(data.id, tmpData)).then(() => {
					setSectionList(resultList)
					setIsSuccessSaveSectionDialogOpen(true)
				})
			}
		} else {
			if (isSectionValid) {
				setSectionList(resultList)
				setIsSuccessSaveSectionDialogOpen(true)
			} else {
				setIsFailSaveSectionDialogOpen(true)
			}
		}
	}

	const mounted = useRef(false)

	const filteredAdjustableStepList = useMemo(() => {
		// add or remove step from template
		let templateStep = JSON.parse(JSON.stringify(templateStepList))?.filter(list => list?.action?.section.includes("evaluate"))
		let stepsPerSection = componentCheckList// componentCheckList.filter(section => section !== "approve" && section !== "signoff") ?? []
		let tmpAdjustedStepList = JSON.parse(JSON.stringify(adjustableStepList))
		let seqCount = tmpAdjustedStepList.sort((a, b) => b.seq - a.seq)?.[0]?.seq ?? 1
		let resultList = []
		const stepSortOrder = ["submit", "evaluate", "review"]
		for (let i = 1; i <= seqCount; i++) {
			for (let j = 0; j < stepsPerSection.length; j++) {
				let isStepExisted = tmpAdjustedStepList?.findIndex(step => step.seq === i && step.action.code === stepsPerSection[j])
				let getTemplateStep = templateStep.find(template => template.action.code === stepsPerSection[j])
				let resultStep = {}
				resultStep = {
					seq: i,
					...getTemplateStep
				}
				if (isStepExisted > -1) {
					resultStep = {
						...tmpAdjustedStepList[isStepExisted]
					}
				}
				resultList.push(resultStep)
			}
		}
		resultList.sort((a, b) => a.seq - b.seq || stepSortOrder.indexOf(a?.action?.code) - stepSortOrder.indexOf(b?.action?.code))
		return resultList.filter(item => componentCheckList.includes(item?.action?.code)).map((filteredItem, index) => {
			return {
				...filteredItem,
				step: index + 1
			}
		})
	}, [componentCheckList, adjustableStepList])

	const filteredFinalStepList = useMemo(() => {
		// add or remove step from template
		let templateStep = JSON.parse(JSON.stringify(templateStepList))?.filter(list => list?.action?.section.includes("final"))
		let stepsPerSection = componentCheckList//componentCheckList.filter(section => section === "approve" || section === "signoff") ?? []
		let tmpFinalStep = JSON.parse(JSON.stringify(stepList))
		let resultList = []
		const stepSortOrder = ["approve", "signoff"]
		for (let j = 0; j < stepsPerSection.length; j++) {
			let isStepExisted = tmpFinalStep?.findIndex(step => step.action.code === stepsPerSection[j])
			let getTemplateStep = templateStep.find(template => template.action.code === stepsPerSection[j])
			let resultStep = {}
			resultStep = {
				...getTemplateStep
			}
			if (isStepExisted > -1) {
				resultStep = {
					...tmpFinalStep[isStepExisted]
				}
			}
			resultList.push(resultStep)
		}
		//resultList.sort((a, b) => stepSortOrder.indexOf(a?.action?.code) - stepSortOrder.indexOf(b?.action?.code))

		let adjustedStepIndex = filteredAdjustableStepList?.[filteredAdjustableStepList.length - 1]?.step
		return resultList?.filter(item => componentCheckList.includes(item?.action?.code)).map((filteredItem, index) => {
			adjustedStepIndex++
			return {
				...filteredItem,
				step: adjustedStepIndex
			}
		}) ?? []
	}, [componentCheckList, stepList, formik.values.evaluationAmount])

	const filteredExtendStepList = useMemo(() => {
		// add or remove step from template
		let templateStep = JSON.parse(JSON.stringify(templateStepList))
		let stepsPerSection = [...componentCheckList]
		let tmpExtendStepList = JSON.parse(JSON.stringify(extendStepList))
		let resultList = []
		const stepSortOrder = ["submit", "evaluate", "review", "approve", "signoff"]
		for (let j = 0; j < stepsPerSection.length; j++) {
			let isStepExisted = tmpExtendStepList?.findIndex(step => step.action.code === stepsPerSection[j])
			let getTemplateStep = templateStep.find(template => template.action.code === stepsPerSection[j])
			let resultStep = {}
			resultStep = {
				...getTemplateStep
			}
			if (isStepExisted > -1) {
				resultStep = {
					...tmpExtendStepList[isStepExisted]
				}
			}
			resultList.push(resultStep)
		}
		//resultList.sort((a, b) => stepSortOrder.indexOf(a?.action?.code) - stepSortOrder.indexOf(b?.action?.code))

		return resultList.filter(item => componentCheckList.includes(item?.action?.code)).map((filteredItem, index) => {
			return {
				...filteredItem,
				step: index + 1
			}
		})
	}, [componentCheckList, extendStepList])

	const previewStepList = useMemo(() => {
		let resultList = [
			...filteredAdjustableStepList,
			...filteredFinalStepList,
			...filteredExtendStepList
		]
		return resultList.map((filteredItem, index) => {
			return {
				...filteredItem,
				step: index + 1
			}
		})
	}, [filteredFinalStepList, filteredAdjustableStepList, filteredExtendStepList])

	// useEffect
	useEffect(() => {
		fetchTemplateData()
		fetchWorkflowData()
		mounted.current = true
		return () => {
			mounted.current = false
		}
	}, [])

	useEffect(() => {
		if (mode === "edit" && workflowData) {
			setOriginalEditData(workflowData)
			setDataForEdit(workflowData)
		}
	}, [mode, workflowData])

	useEffect(() => {
		if (mode !== "edit") {
			formik.setFieldValue("code", state?.code ?? "")
			formik.setFieldValue("type", state?.type ?? "")
		}
	}, [state.code, state.type])

	useEffect(() => {
		setCountStep(filteredFinalStepList.length)
		const checkIsStepValid = () => {
			let result = filteredFinalStepList.findIndex(step => (step.action.code === "submit" && step.status === "active") || (step.action.code === "evaluate" && step.status === "active"))
			return result
		}
		setIsStepValid(checkIsStepValid() > -1)
	}, [filteredFinalStepList])

	useEffect(() => {
		if (componentCheckList.some(checkbox => checkbox == 'submit' || checkbox == 'evaluate' || checkbox == 'review')) {
			setIsComponentCheckboxesValid(true)
		} else {
			setIsComponentCheckboxesValid(false)
		}
	}, [componentCheckList])

	// adjust seq of final steps
	useEffect(() => {
		let adjustedStepIndex = filteredAdjustableStepList?.[filteredAdjustableStepList.length - 1]?.step
		let tmpStepList = [...filteredFinalStepList].map(item => {
			adjustedStepIndex++
			return {
				...item,
				step: adjustedStepIndex
			}
		})
		// setStepList(tmpStepList)
	}, [filteredAdjustableStepList])
	// end useEffect

	return (
		<Grid container mt={3}>
			<Grid item xs={12}>
				<Grid container spacing={4}>
					<Grid item xs={12}>
						<StyledPaper>
							<Grid container mb={1} spacing={4}>
								<Grid item xs={6} display="flex" alignItems="center">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.code")}
									</Typography>
									<RedStarRequired />
								</Grid>
								<Grid item xs={6} display="flex" alignItems="center">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.type")}
									</Typography>
									<RedStarRequired />
								</Grid>
							</Grid>
							<Grid container mb={2} spacing={4}>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											backgroundColor: "#FAFAFA",
											"-webkit-text-fill-color": "#000 !important",
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
										},
										fieldset: { borderColor: "#FFFFFF !important" },
									}}
								>
									<TextField
										sx={{ mt: 0 }}
										fullWidth
										margin="normal"
										name="code"
										disabled
										type="text"
										value={formik.values.code}
										InputLabelProps={{
											shrink: true,
										}}
									/>
								</Grid>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											backgroundColor: "#FAFAFA",
											"-webkit-text-fill-color": "#000 !important",
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
											textTransform: "capitalize"
										},
										fieldset: { borderColor: "#FFFFFF !important" },
									}}
								>
									<TextField
										sx={{ mt: 0 }}
										fullWidth
										margin="normal"
										name="type"
										disabled
										type="text"
										value={formik.values.type}
										InputLabelProps={{
											shrink: true,
										}}
									/>
								</Grid>
							</Grid>
							<Grid container mb={1} spacing={4}>
								<Grid item xs={6} display="flex" alignItems="center">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.name")}
									</Typography>
									<RedStarRequired />
								</Grid>
								<Grid item xs={6} display="flex" alignItems="center">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.status")}
									</Typography>
									<RedStarRequired />
								</Grid>
							</Grid>
							<Grid container mb={2} spacing={4}>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
										},
									}}
								>
									<TextField
										sx={{ my: 0 }}
										error={Boolean(formik.touched.name && formik.errors.name)}
										fullWidth
										margin="normal"
										placeholder={t("adminWorkflow.form.fillTheName")}
										name="name"
										type="text"
										value={formik.values.name}
										onChange={handleName}
										InputLabelProps={{
											shrink: true,
										}}
									/>
									{Boolean(formik.touched.name && formik.errors.name) && <ErrorHelper />}
								</Grid>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
										},
										"& .MuiSwitch-switchBase.Mui-checked.Mui-disabled + .MuiSwitch-track": {
											backgroundColor: "#D8D8D8!important"
										}
									}}
								>
									<IOSSwitch checked={formik.values.status} disabled={isUsed} onChange={() => formik.setFieldValue("status", !formik.values.status)} />
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{formik.values.status ? t("label.active") : t("label.inactive")}
									</Typography>
								</Grid>
							</Grid>
							<Grid container mb={1} spacing={4}>
								<Grid item xs={6} display="flex">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.description")}
									</Typography>
									<RedStarRequired />
								</Grid>
								<Grid item xs={6} display="flex">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.amountOfEvaluation")}
									</Typography>
									<RedStarRequired />
								</Grid>
							</Grid>
							<Grid container mb={2} spacing={4}>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0,
										".MuiInputBase-input": {
											borderRadius: "4px",
											p: "4px 10px",
											height: "35px",
										},
									}}
								>
									<TextField
										error={Boolean(formik.touched.description && formik.errors.description)}
										sx={{ my: 0 }}
										fullWidth
										margin="normal"
										placeholder={t("adminWorkflow.form.fillTheDescription")}
										name="description"
										type="text"
										value={formik.values.description}
										onChange={handleDescription}
										InputLabelProps={{
											shrink: true,
										}}
									/>
									{Boolean(formik.touched.description && formik.errors.description) && <ErrorHelper />}
								</Grid>
								<Grid
									item
									xs={6}
									display="flex"
									alignItems="center"
									flexDirection="column"
									sx={{
										p: 0
									}}
								>
									<FormControl fullWidth>
										<Select
											displayEmpty
											id="cycle-select-form"
											value={formik.values.evaluationAmount}
											onChange={(val) => { handleWillChangeEvaluationAmount(val.target.value) }}
											input={<OutlinedInput size="small" />}
											sx={
												{
													height: "45px"
												}
											}
										>
											{sectionTotal.map((option, idx) => {
												return <MenuItem key={idx} value={option}><Typography style={{ fontWeight: 400, fontSize: '16px', color: '#404349' }}>{option}</Typography></MenuItem>
											})}
										</Select>
									</FormControl>
									{Boolean(formik.touched.evaluationAmount && formik.errors.evaluationAmount) && <ErrorHelper />}
								</Grid>
							</Grid>
							<Grid container mb={1} spacing={4}>
								<Grid item xs={12} display="flex">
									<Typography color="#404349" fontSize={18} fontWeight="500">
										{t("adminWorkflow.form.workflowComponent")}
									</Typography>
									<RedStarRequired />
									{
										!isComponentCheckboxesValid &&
										<Box sx={{ display: "flex", alignItems: "center", justifyContent: "center", ml: 2 }}>
											<AlertRed />
											<FormHelperText
												error={true}
												sx={{ ml: 1, fontSize: "14px" }}
											>
												{
													t("adminWorkflow.label.componentCheckboxError")
												}
											</FormHelperText>
										</Box>
									}
								</Grid>
							</Grid>
							{
								workflowTemplateData?.actions?.map(action => (
									<Grid container mb={2} spacing={0}>
										<Grid
											item
											xs={12}
											display="flex"
											alignItems="center"
											flexDirection="row"
											sx={{
												p: 0,
											}}
										>
											<CustomCheckbox disabled={action.code === "signoff" ? true : false} error={action.code !== "approve" && action.code !== "signoff" && !isComponentCheckboxesValid ? true : false} checked={componentCheckList.includes(action.code)} onChange={() => handleComponentCheckList(action.code)} sx={{ p: 0, mr: 2 }} />
											<Typography>{
												action.label === "Submit" ?
													"Submit (Self-Evaluation)" :
													action.label === "Evaluate" ? "Evaluate (Evaluator Evaluation)" :
														action.label === "Review" ? "Review (1-on-1 Session)" : action.label
											}</Typography>
										</Grid>
									</Grid>
								))
							}
						</StyledPaper>

						<Divider sx={{ my: 4 }} />

						<StyledPaper sx={{ mb: 4 }}>
							<Grid container spacing={4}>
								<Grid item xs={12} display="flex" flexDirection="column">
									<Grid container mb={1}>
										<Grid item xs={12} display="flex" alignItems="center" justifyContent="space-between">
											<Typography color="#404349" fontSize={18} fontWeight="500">
												{t("adminWorkflow.form.evaluationProcessPreview")}
											</Typography>
											<ToggleButtonGroup
												color="primary"
												value={previewLang}
												exclusive
												onChange={handleChangePreviewLang}
												aria-label="Platform"
												size="small"
												sx={{
													"& .MuiToggleButton-root": {
														width: "75px",
														height: "30px",
														fontWeight: 400,
														fontSize: 14,
														textTransform: "none",
													},
													"& .Mui-selected": { borderColor: "#5DA196" },
												}}
											>
												<ToggleButton value="EN">Eng</ToggleButton>
												<ToggleButton value="TH">Thai</ToggleButton>
											</ToggleButtonGroup>
										</Grid>
									</Grid>
									<Grid container mb={2} className={classes.swiperStyles}>
										<Grid item xs={12} display="flex" alignItems="center" >
											<CalendarIcon className={classes.calendarIcon} />
											<Typography color="#404349" fontSize={18} fontWeight="400" sx={{ ml: 1 }} >
												{t("adminWorkflow.form.signOffDueDate")}: 01 Jan 99
											</Typography>
										</Grid>
										<Grid item xs={12} display="flex" alignItems="center" mt={2}>
											{
												previewStepList?.length > 0 ?
													<Swiper
														slidesPerView={4}
														slidesPerGroup={4}
														loop={false}
														pagination={{
															clickable: true,
															type: "fraction"
														}}
														navigation={true}
														modules={[Pagination, Navigation]}
														sx={{ overflow: "unset !important" }}
													>
														<Box sx={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center" }}>
															{
																previewStepList.map((item, index) => {
																	return (
																		<SwiperSlide key={`preview-item-${index}`}>
																			<div
																				style={{
																					// maxWidth: "280px",
																					width: "100%",
																					height: "165px",
																					background: "rgba(93, 161, 150, 0.1)",
																					border: "1px solid #5DA196",
																					borderRadius: "5px",
																					position: "relative",
																				}}
																			>
																				<Box
																					sx={{ p: 1, display: "flex", alignItems: "start" }}
																				>
																					<Box
																						mt="4px"
																						style={{
																							background: "#5DA196",
																							border: "1px solid #5DA196",
																							borderRadius: "50%",
																							width: "30px",
																							height: "30px",
																						}}
																						sx={{
																							display: "flex",
																							alignItems: "center",
																							justifyContent: "center",
																						}}
																					>
																						<ApprovedIcon />
																					</Box>
																					<Box sx={{ ml: 2, width: "calc(100% - 62px)", "margin-right": "16px", }}>
																						<Typography fontSize="16" fontWeight="600"
																							sx={{
																								color: "#404349",
																								wordBreak: "break-all"
																							}}
																						>
																							{checkedLang(item?.description)}
																						</Typography>
																					</Box>
																				</Box>
																				<Box
																					sx={{
																						px: 1,
																						display: "flex",
																						alignItems: "center",
																					}}
																				>
																					<Box
																						style={{
																							width: "30px",
																						}}
																					></Box>
																					<Box sx={{ ml: 2 }}>
																						<Typography fontSize="14px" fontWeight="400" color="#404349">
																							{`${t('label.formStatus')} : ${t('label.completed')}`}
																						</Typography>
																					</Box>
																				</Box>
																				<Box
																					sx={{
																						px: 1,
																						display: "flex",
																						alignItems: "center",
																					}}
																				>
																					<Box
																						style={{
																							width: "30px",
																						}}
																					></Box>
																					<Box sx={{ ml: 2 }}>
																						<Typography fontSize="14px" fontWeight="400" color="#404349">
																							{t('evaluation.submittedDate')}:
																						</Typography>
																					</Box>
																				</Box>
																				<Box
																					sx={{
																						px: 1,
																						pb: 1,
																						display: "flex",
																						alignItems: "center",
																					}}
																				>
																					<Box
																						style={{
																							width: "30px",
																						}}
																					></Box>
																					<Box sx={{ ml: 2 }}>
																						<Typography fontSize="14px" fontWeight="400" color="#404349">
																							{t('evaluation.dueDate')}:
																						</Typography>
																					</Box>
																				</Box>
																				<Box
																					style={{
																						position: "absolute",
																						right: 0,
																						top: 0,
																						margin: 6,
																					}}
																				>
																					<div style={{ width: "max-content" }}>
																						<BootstrapTooltip
																							placement="top"
																							title={checkedLang(item?.tooltip)}
																						>
																							<InfoIcon style={{ cursor: "pointer" }} />
																						</BootstrapTooltip>
																					</div>
																				</Box>
																			</div>
																			<Box
																				sx={{
																					borderTop: previewStepList.length - 1 > index ? "3px dashed #E5E5E5" : "none",
																					width: "100%",
																					maxWidth: "65px"
																				}}
																			/>
																		</SwiperSlide>
																	)
																})
															}
														</Box>
													</Swiper>
													: <></>
											}

										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</StyledPaper>

						<StyledPaper>
							<Grid container>
								<Grid item xs={12}>
									<Grid container mb={2}>
										<Grid item display="flex" alignItems="center">
											<Typography color="#404349" fontSize={18} fontWeight="500">
												{t("adminWorkflow.form.workflowTemplate")}
											</Typography>
											<RedStarRequired />
										</Grid>
									</Grid>
									<Grid container mb="30px">
										<Grid item display="flex" alignItems="center" xs={12}>
											<StyledTableEvaluate sx={{ width: "100%" }} isSubmitButtonClicked={isSubmitButtonClicked} staticData={filteredFinalStepList} dynamicData={filteredAdjustableStepList} sectionData={sectionList} doEdit={handleEditStep} doEditSection={handleEditSectionDialog} isStepValid={isStepValid} doValidate={getValidateSectionData} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</StyledPaper>

						<StyledPaper sx={{ mt: 4 }}>
							<Grid container>
								<Grid item xs={12}>
									<Grid container mb={2}>
										<Grid item display="flex" alignItems="center">
											<Typography color="#404349" fontSize={18} fontWeight="500">
												{t("adminWorkflow.label.workflowTemplateExtend")}
											</Typography>
											<RedStarRequired />
										</Grid>
									</Grid>
									<Grid container mb="30px">
										<Grid item display="flex" alignItems="center" xs={12}>
											<StyledTableEvaluateExtend sx={{ width: "100%" }} data={filteredExtendStepList} sectionData={sectionList} doEdit={handleEditStep} />
										</Grid>
									</Grid>
								</Grid>
							</Grid>
						</StyledPaper>

						<Grid container mt={4} pr={4}>
							<Grid
								item
								display="flex"
								alignItems="center"
								xs="auto"
								ml="auto"
							>
								<Button
									size="small"
									aria-controls="cancle"
									aria-haspopup="true"
									color="black"
									variant="outlined"
									sx={{
										width: "114px",
										height: "45px",
										p: "0",
										textTransform: "none",
									}}
									onClick={() => setIsconfirmDiscardDialogOpen(true)}
								>
									<Typography fontWeight="500" fontSize={18} color="#6B6B6B">
										{t("label.cancel")}
									</Typography>
								</Button>
								<Button
									size="small"
									aria-controls="create"
									aria-haspopup="true"
									color="primary"
									variant="contained"
									disabled={!mounted.current}
									sx={{
										width: "114px",
										height: "45px",
										p: "0",
										textTransform: "none",
										ml: "35px",
									}}
									onClick={() => handleSubmitForm()}
								>
									<Typography fontWeight="500" fontSize={18}>
										{mode === "edit" ? t("label.save") : t("label.create")}
									</Typography>
								</Button>
							</Grid>
						</Grid>
					</Grid>
				</Grid>
			</Grid>
			<WorkflowDialog open={isWorkflowDialogOpen} workflowType="probation" onClose={handleCloseWorkflowDialog} editData={editStepData} addData={{ countStep: countStep, is_send_mail: true }} workflowTemplateData={workflowTemplateData} type={typeWorkflowTemplate} doSubmit={handleSubmitDialog} />
			<EditSectionDialog open={isEditSectionOpen} data={editSectionData} setValue={() => setIsEditSectionOpen(false)} doSaveEditSection={(data) => handleUpdateSectionData(data)} />

			{/* success create dialog */}
			<MessageDialog
				open={isSuccessCreateDialogOpen}
				setValue={handleSuccessCreateDialog}
				title={t('adminWorkflow.dialog.successCreateTitle')}
				text={t('adminWorkflow.dialog.successCreateDesc')}
			/>
			{/* success edit section dialog */}
			<MessageDialog
				open={isSuccessSaveSectionDialogOpen}
				setValue={handleSuccessSaveSectionDialog}
				title={t('adminWorkflow.dialog.successUpdateSectionTitle')}
				text={t('adminWorkflow.dialog.successUpdateSectionDesc')}
			/>
			{/* fail edit section dialog */}
			<MessageDialog
				open={isFailSaveSectionDialogOpen}
				type="fail"
				setValue={handleFailSaveSectionDialog}
				title={t('adminWorkflow.dialog.failUpdateSectionTitle')}
				text={stepType === "final" ? t("adminWorkflow.label.sectionError2") : t("adminWorkflow.label.sectionError1")}
			/>
			{/* success edit dialog */}
			<MessageDialog
				open={isSuccessUpdateDialogOpen}
				setValue={handleSuccessUpdateDialog}
				title={t('adminWorkflow.dialog.successUpdateTitle')}
				text={t('adminWorkflow.dialog.successUpdateDesc')}
			/>
			{/* step empty */}
			<MessageDialog
				open={isStepListEmptyDialogOpen}
				setValue={setIsStepListEmptyDialogOpen}
				type="fail"
				title={t('adminWorkflow.dialog.errorStepListEmptyTitle')}
				text={t('adminWorkflow.dialog.errorStepListEmptyDesc')}
			/>
			{/* confirm discard */}
			<ConfirmDialog
				open={isConfirmDiscardDialogOpen}
				doConfirm={handleConfirmDiscard}
				warning={true}
				setValue={setIsconfirmDiscardDialogOpen}
				title={t("label.confirmationOfDiscard")}
				text={t("label.youSureDiscardChange")}
			/>

			{/* confirm change eval amount */}
			<ConfirmDialog
				open={isConfirmChangeEvalAmountDialogOpen}
				doConfirm={handleConfirmChangeEvalAmount}
				warning={true}
				setValue={setIsConfirmChangeEvalAmountDialogOpen}
				title={t("adminWorkflow.dialog.confirmToChangeEvalAmountTitle")}
				text={t("adminWorkflow.dialog.confirmToChangeEvalAmountText")}
			/>
		</Grid>
	)
}

export default EvaluationProbationWorkflow